<template>
  <div class="nav-dropdown-content" :style="{height: dropdownHeight+'px'}">
    <div ref="navDropdownBox" class="nav-dropdown-box">
      <slot name="navDropdown">
        
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dropdownHeight: 0,
      contentHeight: 0
    }
  },
  mounted () {
    this.contentHeight = this.$refs.navDropdownBox.offsetHeight;
  },
  methods: {
    open(){
      this.dropdownHeight = this.contentHeight;
    },
    close(){
      this.dropdownHeight = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-dropdown-content{
    overflow: hidden;
    transition: all 0.2s linear 0s;
    position: absolute;
    top: 78px;
    left: 0;
    right: 0;
    z-index: 100;
    line-height: 30px;
    color: #999;
    min-width: 100px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
    a{
      color: #999;
    }
    .nav-dropdown-box{
      padding: 10px 0;
      border-radius: 0px 0px 4px 4px;
      background-color: #fff;
      border-radius: 3px;
    }
    .dropdown-item{
      cursor: pointer;
      height: 36px;
      line-height: 36px;
    }
    .dropdown-item:hover{
      background-color: #fafafa;
      color: #333;
      a{
        color: #333;
      }
    }
    .dropdown-item.active{
      background-color: #fff;
      color: #000;
    }
  }
</style>